var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoDataArtwork(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_909_406)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_909_406",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100 0H0V100H100V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_909_406)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73 48C82.9411 48 91 39.9411 91 30C91 20.0589 82.9411 12 73 12C63.0589 12 55 20.0589 55 30C55 39.9411 63.0589 48 73 48Z",
    fill: "#E6DBD7"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_909_406)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.374 22.131H12.5C10.2909 22.131 8.5 23.9218 8.5 26.131V83.068C8.5 85.2771 10.2909 87.068 12.5 87.068H76.374C78.5831 87.068 80.374 85.2771 80.374 83.068V26.131C80.374 23.9218 78.5831 22.131 76.374 22.131Z",
    fill: "#FCFDFE"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M70.7131 32.48H29.3661C28.2991 32.48 27.4341 33.345 27.4341 34.412C27.4341 35.479 28.2991 36.344 29.3661 36.344H70.7131C71.7801 36.344 72.6451 35.479 72.6451 34.412C72.6451 33.345 71.7801 32.48 70.7131 32.48Z",
    fill: "#E4E7EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.956 30.548H18.228C17.1235 30.548 16.228 31.4434 16.228 32.548V36.276C16.228 37.3805 17.1235 38.276 18.228 38.276H21.956C23.0606 38.276 23.956 37.3805 23.956 36.276V32.548C23.956 31.4434 23.0606 30.548 21.956 30.548Z",
    fill: "#1F9254"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.326 35.921C19.298 35.9212 19.2702 35.9154 19.2446 35.9038C19.2191 35.8922 19.1964 35.8752 19.178 35.854L18.163 34.754C18.1274 34.7142 18.109 34.6619 18.1119 34.6085C18.1148 34.5552 18.1388 34.5051 18.1785 34.4695C18.2183 34.4338 18.2706 34.4154 18.324 34.4183C18.3774 34.4212 18.4274 34.4452 18.463 34.485L19.337 35.433L21.758 33.019C21.7955 32.9817 21.8462 32.9608 21.899 32.9608C21.9519 32.9608 22.0026 32.9817 22.04 33.019C22.0773 33.0564 22.0982 33.1071 22.0982 33.16C22.0982 33.2128 22.0773 33.2635 22.04 33.301L19.471 35.863C19.4526 35.8827 19.4301 35.8982 19.405 35.9082C19.38 35.9182 19.353 35.9226 19.326 35.921Z",
    fill: "#FCFDFE",
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.7131 59.915H29.3661C28.2991 59.915 27.4341 60.78 27.4341 61.847C27.4341 62.914 28.2991 63.779 29.3661 63.779H70.7131C71.7801 63.779 72.6451 62.914 72.6451 61.847C72.6451 60.78 71.7801 59.915 70.7131 59.915Z",
    fill: "#E4E7EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.956 57.983H18.228C17.1235 57.983 16.228 58.8784 16.228 59.983V63.711C16.228 64.8155 17.1235 65.711 18.228 65.711H21.956C23.0606 65.711 23.956 64.8155 23.956 63.711V59.983C23.956 58.8784 23.0606 57.983 21.956 57.983Z",
    fill: "#1F9254"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.326 63.356C19.298 63.3562 19.2702 63.3504 19.2446 63.3388C19.2191 63.3272 19.1964 63.3102 19.178 63.289L18.163 62.189C18.1274 62.1492 18.109 62.0969 18.1119 62.0435C18.1148 61.9902 18.1388 61.9401 18.1785 61.9045C18.2183 61.8688 18.2706 61.8504 18.324 61.8533C18.3774 61.8562 18.4274 61.8802 18.463 61.92L19.337 62.868L21.758 60.454C21.7955 60.4167 21.8462 60.3958 21.899 60.3958C21.9519 60.3958 22.0026 60.4167 22.04 60.454C22.0773 60.4914 22.0982 60.5421 22.0982 60.595C22.0982 60.6478 22.0773 60.6985 22.04 60.736L19.471 63.298C19.4526 63.3177 19.4301 63.3332 19.405 63.3432C19.38 63.3532 19.353 63.3576 19.326 63.356Z",
    fill: "#FCFDFE",
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.7131 46.004H29.3661C28.2991 46.004 27.4341 46.869 27.4341 47.936C27.4341 49.003 28.2991 49.868 29.3661 49.868H70.7131C71.7801 49.868 72.6451 49.003 72.6451 47.936C72.6451 46.869 71.7801 46.004 70.7131 46.004Z",
    fill: "#E4E7EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.956 44.072H18.228C17.1235 44.072 16.228 44.9674 16.228 46.072V49.8C16.228 50.9045 17.1235 51.8 18.228 51.8H21.956C23.0606 51.8 23.956 50.9045 23.956 49.8V46.072C23.956 44.9674 23.0606 44.072 21.956 44.072Z",
    fill: "#1F9254"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.326 49.445C19.298 49.4452 19.2702 49.4394 19.2446 49.4278C19.2191 49.4162 19.1964 49.3992 19.178 49.378L18.163 48.278C18.1274 48.2382 18.109 48.1859 18.1119 48.1325C18.1148 48.0791 18.1388 48.0291 18.1785 47.9935C18.2183 47.9578 18.2706 47.9394 18.324 47.9423C18.3774 47.9452 18.4274 47.9692 18.463 48.009L19.337 48.957L21.758 46.543C21.7955 46.5057 21.8462 46.4848 21.899 46.4848C21.9519 46.4848 22.0026 46.5057 22.04 46.543C22.0773 46.5804 22.0982 46.6311 22.0982 46.684C22.0982 46.7368 22.0773 46.7875 22.04 46.825L19.471 49.387C19.4526 49.4067 19.4301 49.4222 19.405 49.4322C19.38 49.4422 19.353 49.4466 19.326 49.445Z",
    fill: "#FCFDFE",
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.7131 73.44H29.3661C28.2991 73.44 27.4341 74.305 27.4341 75.372C27.4341 76.439 28.2991 77.304 29.3661 77.304H70.7131C71.7801 77.304 72.6451 76.439 72.6451 75.372C72.6451 74.305 71.7801 73.44 70.7131 73.44Z",
    fill: "#E4E7EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.956 71.508H18.228C17.1235 71.508 16.228 72.4034 16.228 73.508V77.236C16.228 78.3406 17.1235 79.236 18.228 79.236H21.956C23.0606 79.236 23.956 78.3406 23.956 77.236V73.508C23.956 72.4034 23.0606 71.508 21.956 71.508Z",
    fill: "#1F9254"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.326 76.881C19.298 76.8813 19.2702 76.8754 19.2446 76.8638C19.2191 76.8523 19.1964 76.8352 19.178 76.814L18.163 75.714C18.1274 75.6742 18.109 75.6219 18.1119 75.5685C18.1148 75.5152 18.1388 75.4652 18.1785 75.4295C18.2183 75.3938 18.2706 75.3754 18.324 75.3783C18.3774 75.3812 18.4274 75.4052 18.463 75.445L19.337 76.393L21.758 73.979C21.7955 73.9417 21.8462 73.9208 21.899 73.9208C21.9519 73.9208 22.0026 73.9417 22.04 73.979C22.0773 74.0165 22.0982 74.0672 22.0982 74.12C22.0982 74.1728 22.0773 74.2235 22.04 74.261L19.471 76.823C19.4526 76.8428 19.4301 76.8582 19.405 76.8682C19.38 76.8783 19.353 76.8826 19.326 76.881Z",
    fill: "#FCFDFE",
    stroke: "white",
    strokeWidth: 0.5
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_909_406",
    x: 8.5,
    y: 22.131,
    width: 79.874,
    height: 72.937,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.831373 0 0 0 0 0.85098 0 0 0 0 0.909804 0 0 0 0.302 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_909_406"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_909_406",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_909_406"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDataArtwork);
export default __webpack_public_path__ + "static/media/no_data_artwork.88165f328cade19d973dbe6b97bb33ef.svg";
export { ForwardRef as ReactComponent };